module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ka-Lb.a42b8741.png";